import styled from 'styled-components';
import { COLORS } from '../../ui';

interface Props {
  imgHeight?: string;
}

export const RadioButtonStyled = styled.input`
  cursor: pointer;
  height: 20px;
  margin-right: 20px;
  width: 20px;
`;

export const RadioButtonChecked = styled.span`
  border: 1px solid ${COLORS.BORDER_GRAY};
  border-radius: 50%;
  height: 20px;
  left: 0;
  margin-left: 20px;
  position: absolute;
  width: 20px;

  ${RadioButtonStyled}:checked + && {
    background-color: ${COLORS.BLACK}};
    border: 4px solid ${COLORS.LIGHT_GRAY};
  };
`;

export const RadioButtonLabel = styled.label`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 24px;
`;

export const RadioButtonWrapper = styled.div`
  align-items: center;
  border: 2px ${COLORS.BORDER_GRAY};
  border-radius: 5px;
  border-style: solid;
  box-sizing: border-box;
  display: flex;
  height: 94px;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 0 20px;
  position: relative;
  width: 100%;
`;

export const RadioButtonLogo = styled.div`
  height: ${(props: Props) => props.imgHeight ? `${props.imgHeight}` : '100%'};
`;

export const RadioButtonImage = styled.img`
  height: 100%;
`;
